// extracted by mini-css-extract-plugin
export default {"avatar":"CRvLY05p0OXmgSFbLf5K"};